import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Button, Group, Pagination, TextInput, Modal, ScrollArea, Drawer, Badge } from '@mantine/core' 
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllRequestQuoteList, deleteRequestQuote, getDetailRequestQuotePrice } from '../../../../services/request-quote'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableProductQuote from '../../../../component/pages/ProductQuote/TableProductQuote'
import { useDebouncedCallback } from '@mantine/hooks'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import FormProductQuote from '../../../../component/pages/ProductQuote/FormProductQuote'
import FormUploadImages from '../../../../component/pages/ProductQuote/FormUploadImages'
import FormAttachDocument from '../../../../component/pages/ProductQuote/FormAttachDocument'
import ShareLinkProductQuote from '../../../../component/pages/ProductQuote/ShareLinkProductQuote'
import FormChangeStatus from '../../../../component/pages/ProductQuote/FormChangeStatus'
import FormFilterQuotes from '../../../../component/pages/ProductQuote/FormFilterQuotes'
import FormQuoteSetPrices from '../../../../component/pages/ProductQuote/FormQuoteSetPrices'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-created_at',
  include: 'user,documents,creator,updater,supplier,product,product_request,agent',
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Image',
    width: 100
  },
  {
    label: 'Product Name',
    width: 200
  },
  {
    label: 'Quote Type',
    width: 100
  },
  {
    label: 'User',
    width: 170
  },
  {
    label: 'Created By',
    width: 170
  },
  {
    label: 'Updated By',
    width: 170
  },
  {
    label: 'Status',
    width: 170
  },
  {
    label: 'Action',
    width: 50
  },
]

const ProductQuotes = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [productQuoteList, setProductQuoteList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [openModalSetPrice, setOpenModaSetPrice] = useState(false)
  const [openModalUploadImage, setOpenModalUploadImage] = useState(false)
  const [openModalAttachDocument, setOpenModalAttachDocument] = useState(false)
  const [openModalChangeStatus, setOpenModalChangeStatus] = useState(false)
  const [openModalShareLink, setOpenModalShareLink] = useState(false)
    const [openModalFilter, setOpenModalFilter] = useState(false)
  const [detailData, setDetailData] = useState(null)
  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Request',
      route: null
    },
    {
      label: 'Product Quotes',
      route: null
    },
  ]

  const handleGetListRequestQuote = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllRequestQuoteList(params)
      if (response.success) {
        const dataProductQuote = response.data
        const pickIncludedCreator = response.included.creator || []
        const pickIncludedUpdater = response.included.updater || []
        const pickIncludedUser = response.included.user || []
        const pickIncludedAgent = response.included.agent || []
        const pickIncludedStatuses = response.included.statuses || []
        const pickIncludedDocument = response.included.documents || []
        const countData = response.meta.pagination.total

        const getDataUser = (creatorId, included) => {
          let data = null
          const findCreator = included[creatorId]
          if (findCreator) {
            data = {
              id: findCreator.attributes.id,
              name: findCreator.attributes.name
            }
          }
          return data
        }

        const getStatus = (dataStatus) => {
          const remapData = dataStatus.map((val) => {
            return {
              id: pickIncludedStatuses[val.id].attributes.id,
              name: pickIncludedStatuses[val.id].attributes.name
            }
          })
          return remapData
        }

        const getDocument = (dataDocument) => {
          const remapData = dataDocument.map((val) => {
            return {
              id: pickIncludedDocument[val.id].attributes.id,
              name: pickIncludedDocument[val.id].attributes.name,
              url: pickIncludedDocument[val.id].attributes.url
            }
          })
          return remapData
        }

        const handleAssignVariant = (data, included) => {
          const includedVariation = included.product_variation

          const handleGetProductVariation = (productVariationId) => {
            const remappingData = {
              id: includedVariation[productVariationId].attributes.id,
              image: includedVariation[productVariationId].attributes.image_url,
              options_values: includedVariation[productVariationId].attributes.options_values
            }
            return remappingData
          }

          const generateVariantSpecification = (data) => {
            const remap = data.options_values.map((val) => val.option)
            return remap.join(' - ') 
          }

          const remapData = data.map((val) => {
            const { attributes } = val
            const { product_variation_id, specification, qty, supplier_price, description } = attributes

            const getVariant = Boolean(product_variation_id)
            const dataVariant = getVariant ? handleGetProductVariation(product_variation_id) : null
            const _logicSpesification = getVariant ? generateVariantSpecification(dataVariant) : `${specification.name} - ${specification.option}`

            // importan for grouping
            const generateVariantSpesification = () => {
              return `${_logicSpesification} ${qty} ${supplier_price} ${description}`
            } // FE-1078, flag for grouping is't only by variant name

            const remap = {
              ...val.attributes,
              shipping_type: val.attributes.shipping_type.name,
              variant: dataVariant,
              variant_specification: generateVariantSpesification(),
            }
            return remap
          })

          return remapData
        }

        const handleGroupingVariant = (data) => {
          const groupVariant = {}
          const hasVariant = Boolean(data[0].product_variation_id)

          const remap = data.reduce((result, val) => {
            const selectedData = hasVariant ? val.variant.options_values[0] : val.specification
            const { variant_specification } = val
            if (!groupVariant[variant_specification]) {
              const filterRecentVariant = data.filter(value => value.variant_specification === variant_specification)
              groupVariant[variant_specification] = {
                request_quote_id: val.request_quote_id,
                name: selectedData.name,
                option: selectedData.option,
                supplier_price: val.supplier_price,
                landed_cost_currency: val.landed_cost_currency,
                supplier_currency: val.supplier_currency,
                description: val.description,
                weight: val.weight,
                height: val.height,
                width: val.width,
                length: val.length,
                volume: val.volume,
                dimension_unit: val.dimension_unit,
                bulk_unit: val.bulk_unit,
                bulk_qty: val.bulk_qty,
                bulk_qty_per_unit: val.bulk_qty_per_unit,
                qty: val.qty,
                variant_specification: val.variant_specification,
                image: hasVariant ? val.variant.image : val.image,
                recent_variants: filterRecentVariant
              }
              result.push(groupVariant[variant_specification])
            }
            return result
          }, [])
          return remap
        }

        const handleGetQuotePrice = (data) => {
          const groupVariant = {}
          const remap = data.reduce((result, val) => {
            const { shipping_type } = val
            if (!groupVariant[shipping_type]) {
              groupVariant[shipping_type] = {
                product_variation_id: val.product_variation_id,
                landed_cost_currency: val.landed_cost_currency,
                shipping_type: val.shipping_type,
                supplier_currency: val.supplier_currency,
                landed_cost: 0,
              }
              result.push(groupVariant[shipping_type])
            }
            return result
          }, [])
          return remap
        }

        const remapData = await Promise.all(dataProductQuote.map( async (val) => {
          const getQuotePrice = await handleGetRequestQuotePrice(val.attributes.id)
          const getDataVariant = handleAssignVariant(getQuotePrice.data, getQuotePrice.included)

          const dataRelationships = val.relationships
          const dataCreator = dataRelationships.creator
          const dataUpdater = dataRelationships.updater
          const dataStatuses = dataRelationships.statuses
          const dataDocuments = dataRelationships.documents
          const remap = {
            id: val.attributes.id,
            product_name: val.attributes.product_name,
            creator: dataCreator ? getDataUser(dataCreator.id, pickIncludedCreator) : null,
            created_at: val.attributes.created_at,
            updater: dataUpdater ? getDataUser(dataUpdater.id, pickIncludedUpdater) : null,
            updated_at: val.attributes.updated_at,
            status: dataStatuses.length > 0 ? getStatus(dataStatuses) : [],
            documents: dataDocuments.length > 0 ? getDocument(dataDocuments) : [],
            origin_country_id: val.attributes.origin_country_id.attributes.id,
            destination_country_id: val.attributes.destination_country_id.attributes.id,
            signature: val.attributes.signature,
            short_url: val.attributes.short_url,
            image: val.attributes.image,
            quote_type: val.attributes.quote_type.value,
            original_source_url: val.attributes.original_source_url,
            product_id: val.attributes.product_id,
            package_type: val.attributes.package_type,
            terms: val.attributes.terms,
            product_request_id: val.attributes.product_request_id,
            user: val.attributes.user_id !== null ? getDataUser(val.attributes.user_id, pickIncludedUser) : null,
            agent: val.attributes.agent_id !== null ? getDataUser(val.attributes.agent_id, pickIncludedAgent) : null,
            sales_by: val.attributes.sales_by,
            expired_date: val.attributes.expired_date,
            quantity_unit: val.attributes.quantity_unit,
            description: val.attributes.description,
            variants: handleGroupingVariant(getDataVariant),
            detail_price: handleGetQuotePrice(getDataVariant),
            supplier_id: val.attributes.supplier_id,
            weight: val.attributes.weight,
            volume: val.attributes.volume
          }
          return remap
        }))

        setProductQuoteList(remapData)
        setTotalData(countData)
      } else {
        setProductQuoteList([])
        setTotalData(1)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 500)

  const handleGetRequestQuotePrice = async (quoteId) => {
    const params = {
      'include': 'product_variation'
    }
    try {
      const response = await getDetailRequestQuotePrice(quoteId, params)
      return response
    } catch (error) {
      console.log(error)
    }
  }



  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetListRequestQuote()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setOpenModalForm(true)
      setDetailData(val)
    },
    editPrice: (val) => {
      setOpenModaSetPrice(true)
      setDetailData(val)
    },
    uploadImage: (val) => {
      setOpenModalUploadImage(true)
      setDetailData(val)
    },
    attachDocument: (val) => {
      setOpenModalAttachDocument(true)
      setDetailData(val)
    },
    changeStatus: (val) => {
      setOpenModalChangeStatus(true)
      setDetailData(val)
    },
    shareLink: (val) => {
      setOpenModalShareLink(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('product quotes', val.id, val.product_name, deleteRequestQuote, handleGetListRequestQuote)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangeFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  const onCloseModalUploadImage = () => {
    setOpenModalUploadImage(false)
    setDetailData(null)
  }

  const onCloseModalAttachDocument = () => {
    setOpenModalAttachDocument(false)
    setDetailData(null)
  }

  const onCloseModalChangeStatus = () => {
    setOpenModalChangeStatus(false)
    setDetailData(null)
  }

  const onCloseModalShareLink = () => {
    setOpenModalShareLink(false)
    setDetailData(null)
    handleGetListRequestQuote()
  }

  const onCloseModalSetPrice = () => {
    setOpenModaSetPrice(false)
    setDetailData(null)
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

  const mappingFilterQuote = (parameter) => {
      if (parameter['filter[quote_type][is]'] || parameter['filter[statuses.id][is]'] || parameter['filter[user_id][is]'] || parameter['filter[agent_id][is]']) {
        return (
          <Box>
            <Group gap='sm' align='center' mb={12}>
              {parameter['filter[quote_type][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Quote Type: {parameter['filter[quote_type][is]']}</Badge> : ''}
              {parameter['filter[statuses.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Statuses: {parameter['filter[statuses.id][is]']}</Badge> : ''}
              {parameter['filter[user_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>User: {parameter['filter[user_id][is]']}</Badge> : ''}
              {parameter['filter[agent_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Agent: {parameter['filter[agent_id][is]']}</Badge> : ''}
            </Group>

            <Group align='center' gap='sm'>
              <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
              <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
            </Group>
          </Box>
        )
      }
    }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Product Quotes</Text>
            <Group gap='sm' align='center'>
              <TextInput
                value={params['filter[product_name][like]']}
                placeholder='Search by product name'
                onChange={(val) => {
                  handleChangeFilter('filter[product_name][like]', val.target.value)
                  handleChangePage(1)
                }}
                size='xs'
              />
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add New Quote</Button>
            </Group>
          </Flex>
        </Box>

        {mappingFilterQuote(params)}

        <Box my={30}>
          {loading ? <LoadingData /> : productQuoteList.length > 0 ? <TableProductQuote label={labelTable} data={productQuoteList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Product Quote</Text>} withCloseButton={false}>
        <FormProductQuote dataProductQuote={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetListRequestQuote} />
      </Modal>
      <Modal opened={openModalUploadImage} onClose={onCloseModalUploadImage} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Upload Image Product Quote</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormUploadImages dataProductQuote={detailData} onCloseModal={onCloseModalUploadImage} reloadList={handleGetListRequestQuote} />
      </Modal>
      <Modal opened={openModalAttachDocument} onClose={onCloseModalAttachDocument} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Attach Document</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormAttachDocument dataProductQuote={detailData} onCloseModal={onCloseModalAttachDocument} reloadList={handleGetListRequestQuote} />
      </Modal>
      <Modal opened={openModalChangeStatus} onClose={onCloseModalChangeStatus} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Change Status</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormChangeStatus dataProductQuote={detailData} onCloseModal={onCloseModalChangeStatus} reloadList={handleGetListRequestQuote} />
      </Modal>
      <Modal opened={openModalShareLink} onClose={onCloseModalShareLink} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Share Quote Detail #{detailData !== null ? detailData.id : ''} URL</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <ShareLinkProductQuote dataProductQuote={detailData} onCloseModal={onCloseModalShareLink} />
      </Modal>
      <Modal opened={openModalSetPrice} onClose={onCloseModalSetPrice} centered closeOnClickOutside={false} size='70%' title={<Text fw='Bold'>Set Landed Cost per Unit</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormQuoteSetPrices dataProductQuote={detailData} onCloseModal={onCloseModalSetPrice} reloadList={handleGetListRequestQuote} />
      </Modal>
      <Drawer position='right' title='Filter Product Quotes' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormFilterQuotes paramsQuotes={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
      </Drawer>
    </AuthLayout>
  )
}

export default ProductQuotes